import { Breadcrumbs, Tag } from "@vesatogo/grass-core"
import { Cell, TableView } from "@vesatogo/grass-table"
import { useMemo } from "react"
import { Link, useParams } from "react-router-dom"
import { useUploaderDetailQuery } from "~/generated/graphql"

const COLUMNS = [
  {
    Header: "Id no.",
    accessor: "id",
    Cell({ value }) {
      if (!value) return "--"
      return <Cell title={value} />
    },
  },
  {
    Header: "Error",
    accessor: "error",
    Cell({ value }) {
      if (!value) return "--"
      return (
        <Cell
          title={
            <Tag intent="danger" variant="minimal">
              {value}
            </Tag>
          }
        />
      )
    },
  },
]

export const UploaderTaskDetail = () => {
  const { id } = useParams()

  const [{ data, fetching }] = useUploaderDetailQuery({
    variables: {
      id: parseInt(id as string),
    },
    pause: !id,
  })

  const errors = useMemo(() => {
    const err = JSON.parse(
      data?.django_celery_results_taskresult_by_pk?.result || "{}"
    )?.errors

    const errorArray = [] as any
    for (const key in err) {
      for (const key2 in err[key]) {
        const errorMessage = err?.[key]?.[key2] || ""
        const idMatch = errorMessage.match(/id:\s*(\d+)/)
        if (idMatch) {
          errorArray.push({
            id: idMatch?.[1],
            error: errorMessage,
          } as any) // Push the object to the array
        } else {
          errorArray.push({ error: errorMessage } as any)
        }
      }
    }
    return errorArray
  }, [data])

  return (
    <>
      <header className="bg-gray-100 shadow-sm p-3 border-b-gray-300 border-b flex justify-between">
        <Breadcrumbs
          items={[
            {
              text: "Listing",
              link: "/d/uploader",
              isActive: false,
            },
            {
              text: id?.toString() || "",
              link: `/d/uploader/${id}`,
              isActive: true,
            },
          ]}
          linkRenderer={(link, item) => {
            return <Link to={link as any}>{item}</Link>
          }}
        />
      </header>
      <TableView
        relative={false}
        className="!h-[calc(100vh-64px-57px)]"
        tableClassName=" h-full bg-white"
        columns={COLUMNS}
        isLoading={fetching}
        getRowProps={({ original }) => ({
          className:
            original?.seller?.user[0]?.is_blocked ||
            original?.buyer?.user[0]?.is_blocked
              ? "bg-red-100 hover:bg-red-100"
              : "",
        })}
        data={errors || []}
        meta={<>{errors?.length} errors</>}
      />
    </>
  )
}

export default UploaderTaskDetail
